// The platform shell (UISideNav / ProtectedPage) has no shared "current product" state — a
// product area is identified purely by the URL path prefix, the same way the nav decides which
// product button is active. The CI product spans several roots (see config/routes.rb) that don't
// share a single prefix: its entry point and overview (/ci/:workspace_slug, plus project creation
// under /ci/:workspace_slug/configs/new), the projects list (/apps/*, including /apps/add/cli),
// per-project pages (which also nest builds, pipelines and settings under /app/:app_slug/...), and
// standalone build pages.
const CI_PRODUCT_PATH_PREFIXES = ['/apps', '/app/', '/build/', '/ci/'];

// Bare /ci (the entry point, which 302s to /ci/:workspace_slug) is matched exactly — putting '/ci'
// in the prefix list would also match unrelated roots like /circle.
export const isCiProductArea = (pathname: string = window.location.pathname): boolean =>
  pathname === '/ci' || CI_PRODUCT_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
